import { defineComponent as a, ref as l, watch as u } from "vue";
import n from "./index6.js";
import { DialogLayout as s, DIALOG_VARIANTS as i } from "@ado/acs-standard-library";
const g = a({
  name: "CountrySelectorMoreDialog",
  components: {
    CountrySelectorMore: n,
    DialogLayout: s
  },
  props: {
    showDialog: {
      Boolean,
      default: !0
    },
    countries: {
      type: Array,
      required: !0
    },
    currentCountry: {
      type: Object,
      required: !0
    }
  },
  setup(r, { emit: o }) {
    const e = l(r.showDialog);
    return u(
      () => e.value,
      (t) => {
        o("update:showDialog", t);
      }
    ), { VARIANTS: i, closeDialog: () => {
      o("update:showDialog", !1);
    }, shouldShowDialog: e };
  }
});
export {
  g as default
};
//# sourceMappingURL=index5.js.map
